import React, { Component } from "react";
import { Panel, Alert, Image } from "react-bootstrap";
import Loader from "src/js/Loader.js";
import { msgs } from "src/js/ErrorMessage.js";
import RankingCharacter from "src/img/Ranking Character.png"
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class RankingScore extends Component {

  // ランキングの位置によって人型の位置を変化させるための設定
  chartStyle(){
    let left = this.props.rankingInfo.topPercent;
    if(left <= 5){
      left = 5;
    }
    else if(left >= 95){
      left = 95;
    }
    let style = 
      {
        position: 'absolute',
        top: "30%", 
        left: (left - 3) + "%"
      }
    return style;
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {(() => {
          return (
            <Alert bsStyle="danger" className="alert-margin">
              <p>{t("Message." + msgs["msg_common_01"])}</p>
            </Alert>
          );
        })()}
      </div>
    );

    const Score = () => (
      <span>
        {(() => {
          return (
            this.props.rankingInfo && this.props.rankingInfo.topPercent >= 75 ? (
              <div className="evaluation-box ranking-top">
                <p>{t('Ranking.Top')} 25%</p>
                <p>{t('Ranking.GreatJob')}</p>
              </div>
            ) :
            this.props.rankingInfo && this.props.rankingInfo.topPercent >= 50 ? (
              <div className="evaluation-box ranking-above-middle">
                <p>{t('Ranking.Top')} 50%</p>
                <p>{t('Ranking.RoomToImprove')}</p>
              </div>
            ) :
            this.props.rankingInfo && this.props.rankingInfo.topPercent >= 25 ? (
              <div className="evaluation-box ranking-under-middle">
                <p>{t('Ranking.Bottom')} 50%</p>
                <p>{t('Ranking.Improve')}</p>
              </div>
            ) : (
              <div className="evaluation-box ranking-bottom">
                <p>{t('Ranking.Bottom')} 25%</p>
                <p>{t('Ranking.Improve')}</p>
              </div>
            )
          );
        })()}
      </span>
    );

    return (
      <Panel>
        {
          // ローディング判定
          this.props.loading ? (
            <Loader />
          ) : // データ取得判定
          this.props.isData ? (
            <div>
              <div className="score-title">
                {t('Ranking.YourRank')}<br/>{this.props.rankingInfo.ranking}
              </div>
              <div className="ranking-chart">
                <div id="ranking-chart-rectangle"></div>
                <Image src={RankingCharacter} id="ranking-chart-position" style={this.chartStyle()}
                ></Image>
              </div>
              <div className="percent-label">
                <div>
                  <div id="one-fourth-line"></div>
                  <p id="one-fourth-text">25%</p>
                </div>
                <div>
                  <div id="center-line"></div>
                  <p id="center-text">50%</p>
                </div>
                <div>
                  <div id="three-fourths-line"></div>
                  <p id="three-fourths-text">75%</p>
                </div>
              </div>
              <div className="score-evaluation">
                <Score />
              </div>
            </div>
          ) : (
            <Error />
          )
        }
      </Panel>
    );
  }
}

export default withTranslation()(RankingScore);


// WEBPACK FOOTER //
// ./src/component/Ranking/RankingScore.js